var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('van-nav-bar',{attrs:{"title":"请选择您要购买的商品","fixed":"","placeholder":""}}),_c('van-empty',{attrs:{"description":"暂无可用商品"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }